import React from 'react'
import s from './OrDivider.scss'

export default () => <div className={s.divider}>or</div>



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/components/OrDivider/OrDivider.jsx